import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">3.0.2 Case 2</h1>
            <p className="me-4">Estimated time to complete: 3-5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="A"
            assessmentName="self_assessment_102"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                  This is self-assessment case number 102. This is a positive
                  case. There are multiple areas throughout this case that make
                  this scan positive. However, this particular slice shows many
                  of them. Beginning with the left-hand side, you can see that
                  there is loss of gray-white contrast throughout the temporal
                  and occipital regions. White matter tracts are not
                  identifiable on the left-hand side. On the right-hand side,
                  again, there is loss of gray-white contrast in the right
                  temporal lobe, and a white matter tract is not easily seen. In
                  the frontal cortices bilaterally, there is continued loss of
                  gray-white contrast. The white matter tracts cannot be
                  followed here, on the right side, or on the left-hand side.
                  Therefore, there is loss of gray-white contrast in the
                  frontal, temporal, and left occipital region, making this scan
                  positive. In addition, there is focal intense uptake over
                  here, at the junction of the right temporal and occipital
                  lobes. This intense uptake is located within the gray matter
                  and exceeds that of the adjacent white matter. This scan is
                  also positive, then, because of this focal intense uptake
                  within the gray matter. Other regions within this brain are
                  also abnormal and show loss of gray-white contrast. I invite
                  you to look at this case, once again, in the MIMcloud Viewer,
                  to review these additional locations.
                </p>
              </>
            }
            previousLesson="/module-3/module-3-0-1"
            nextLesson="/module-3/module-3-0-3"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1767175553&entry_id=1_9fahibrt&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="assessment"
            videoId="1_9fahibrt"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_1_0;
